var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSolidArrowDown = function SvgSolidArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "Arrow pointing down",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.334 10a.334.334 0 0 0-.227.578l4.438 3.911a.667.667 0 0 0 .91 0l4.438-3.911a.334.334 0 0 0-.227-.578z",
    clipRule: "evenodd"
  })));
};
export default SvgSolidArrowDown;